<template>
  <div class="nav-container">
    <div class="w98 nav-inner">
      <!-- 2019年11月29日 蓬江区 临时判断 -->
      <div class="logo--text" v-if="isPengJiang">蓬江百姓随手拍</div>
      <div
        v-else
        class="logo"
        :class="$store.state.apptype == 'ipy' ? 'ipy' : 'bkcc'"
      >
      </div>
      <!-- 标语 -->
      <div v-if="navText" class="nav-text">{{ navText }}</div>
      <!-- 导航条 -->
      <div v-else>
        <ul class="nav-list gt1100" @click.stop="switchNav">
          <li
            class="nav-item"
            :class="{ active: navIndex == index }"
            v-for="(item, index) in navItems"
            :key="item.text"
            :data-index="index"
          >
            {{ item.text }}
          </li>
        </ul>
        <!-- 媒体查询的下拉 开始-->
        <Dropdown trigger="click" class="dropdown lt1100" @on-click="menuClick">
          <!-- 下拉标题 -->
          <div class="dropdown-title">
            菜单
            <Icon type="ios-menu-outline" />
          </div>
          <!-- 下拉列表 -->
          <DropdownMenu
            slot="list"
            class="dropdown-menu"
            @click.stop="switchNav"
          >
            <DropdownItem
              class="dropdown-item"
              v-for="(item, index) in navItems"
              :key="item.text"
              :data-index="index"
              :name="index"
              >{{ item.text }}</DropdownItem
            >
          </DropdownMenu>
        </Dropdown>
        <!-- 媒体查询的下拉 结束-->
      </div>

      <div class="nav-slot-warpper">
        <slot>
          <!-- slot 默认值 -->
          <!-- 账号设置 和 新消息提醒 -->
          <div class="account" @mouseleave="mouseLeave">
            <div class="notice">
              <div class="iconfont icon-gonggao" @click="goSysNotice">
                <span class="notice-number">{{ noticeNumber }}</span>
              </div>
            </div>
            <div class="account-info" @mouseover="mouseOver">
              <img v-if="isHead" class="gzh-pic" :src="GZHhead" />
              <img v-else class="gzh-pic" src="../assets/images/default.png" />

              <div class="info-detail">
                <div v-if="isName" class="detail-name">{{ userName }}</div>
                <div v-else class="detail-name">未绑定公众号</div>
                <div class="detail-type">{{ userType }}</div>
              </div>
            </div>
            <div class="zhanwei"></div>
            <div class="qp" :style="display">
              <div class="system" @click="toAdmin" v-if="isShowManage">
                <i class="iconfont icon-shezhi" style="margin-right: 5px"></i>
                系统设置
              </div>
              <div class="unLogin" @click="unLogin">
                <i class="iconfont icon-tuichu" style="margin-right: 5px"></i>
                退出登录
              </div>
            </div>
          </div>
        </slot>
      </div>
    </div>
    <!-- 系统公告弹窗 -->
    <Modal
      v-model="newNotice"
      class-name="vertical-center-modal"
      :closable="false"
      @on-ok="goDetail"
      ok-text="查看"
    >
      <div class="not-con">
        <img :src="picUrl" class="not-pic" alt />
        <p class="n-context">{{ sysTitle }}</p>
      </div>
    </Modal>
  </div>
</template>

<script>
import SockJS from "sockjs-client";
import Stomp from "stompjs";
export default {
  data() {
    return {
      noticeNumber: "0",
      userType: "公众号",
      display: "display: none",
      websock: null,
      newNotice: false,
      picUrl: "",
      sysTitle: "",
      sysId: "",
      timer: null,
      //isShowManage:false
    };
  },
  methods: {
    mouseOver() {
      clearTimeout(this.timer);
      this.display = "";
    },
    mouseLeave() {
      this.timer = setTimeout(() => {
        this.display = "display: none";
      }, 800);
    },
    getSetting() {
      var url = this.urlobj.getMiniSet;
      this.$get(url).then(res => {
        var navItems = [];
        let data = res.rows[0].pc.filter(item => item.isShow == 1);
        data.forEach(item => {
          if (item.moduleValue == "page_home") {
            navItems.push({
              text: item.moduleName,
              url: "/Shouye",
              type: "page_home"
            });
          } else if (item.moduleValue == "page_party") {
            navItems.push({
              text: item.moduleName,
              url: "/miniParty",
              type: "page_party"
            });
          } else if (item.moduleValue == "page_zone") {
            navItems.push({
              text: "微社区",
              url: "/miniCommunity",
              type: "page_zone"
            });
          } else if (item.moduleValue == "page_community_application") {
            navItems.push({
              text: item.moduleName,
              url: "/Shequ",
              type: "page_community_application"
            });
          } else if (item.moduleValue == "page_community_management") {
            let isShowManage = this.$store.state.userWorker == '1'?item.isShow:0;
            // if(item.isShow && item.children.length){
            //   let social_worker = item.children.filter(_item=>_item.moduleValue == 'userSocialWorker');
            //   isShowManage = social_worker.length?social_worker[0].isShow:false;
            // }
            this.isShowManage = isShowManage
            if(isShowManage){
              navItems.push({
                text: item.moduleName,
                url: "/userManager",
                type: "page_community_management"
              });
           }
            
          }
        });
        this.$store.commit("updateNavigator", JSON.stringify(navItems));
      });
    },
    switchNav(e) {
      if (e.target.nodeName == "LI") {
        let navIndex = e.target.dataset.index;
        if (this.navItems[navIndex].type == "page_community_application") {
          var name = "",
            sideBar = JSON.parse(this.$store.state.shequSideBar);
          if (sideBar[0].children) {
            name = sideBar[0].children[0].router;
            sideBar[0].showChild = 1;
            this.$store.commit("updateShequSideBar", JSON.stringify(sideBar));
          } else name = sideBar[0].router;
          this.$router.push({ name });
        } else {
          this.$router.push(this.navItems[navIndex].url);
        }
        this.$store.commit("updateChildrenInd", 0);
        this.$store.commit("updateSideIndex", 0);
      }
    },
    menuClick(index) {
      this.$router.replace(this.navItems[index].url);
      this.$store.commit("updateChildrenInd", 0);
      this.$store.commit("updateSideIndex", 0);
    },
    toAdmin() {
      this.$router.replace("/Administrator/basic");
    },
    unLogin() {
      this.$post(this.urlobj.logOut).then(res => {
        sessionStorage.clear();
        if (
          window.location.host.indexOf("localhost") > -1 ||
          window.location.host.indexOf("ceshi.shequyun") > -1 ||
          window.location.host.indexOf("py.shequyun") > -1 
        ) {
          this.$router.push({ name: "showProduct1" });
        }else{
          this.$router.push({ name: "NewLogin" });
        }
      });
    },
    /**websocket相关函数BEGIN */

    initWebSocket() {
      this.connection();
      // 断开重连机制,尝试发送消息,捕获异常发生时重连
      this.timer = setInterval(() => {
        try {
          this.stompClient.send("test");
        } catch (err) {
          console.log("断线了: " + err);
          this.connection();
        }
      }, 5000);
    },
    connection() {
      // 建立连接对象
      var url = "";
      if (process.env.NODE_ENV === "production") {
        url = location.origin + `/jczl_websocket`;
      } else {
        url = "https://yanfa.shequyun.cn/jczl_websocket";
      }
      let socket = new SockJS(url);
      // 获取STOMP子协议的客户端对象
      this.stompClient = Stomp.over(socket);
      // 定义客户端的认证信息,按需求配置
      let headers = {};
      // 向服务器发起websocket连接
      this.stompClient.connect(
        headers,
        frame => {
          this.stompClient.subscribe(
            `/topic/sys-notice/${this.$store.state.streetorcommunityid}/${
              this.$store.state.uid
            }`,
            msg => {
              // 订阅服务端提供的某个topic
              var notice = JSON.parse(msg.body).messageMap;
              if (notice.unreadNum || notice.unreadNum == 0) {
                this.noticeNumber = notice.unreadNum;
              }
              if (notice.isPop == 1) {
                this.sysTitle = notice.title;
                this.sysId = notice.id;
                this.picUrl = notice.coverPicUrl;
                this.newNotice = true;
              } else if (notice.id) {
                this.openNotice(notice);
              }
            }
          );
        },
        err => {
          // 连接发生错误时的处理函数
          console.log("失败");
          console.log(err);
        }
      );
    },
    disconnect() {
      if (this.stompClient) {
        this.stompClient.disconnect();
      }
    },
    /**websocket相关函数END */
    goSysNotice() {
      this.$router.push({ name: "sysNotice" });
    },
    goDetail() {
      this.$router.push({
        name: "sysNotDetail",
        query: { id: this.sysId }
      });
    },
    openNotice(data) {
      let config = {
        title: data.linkType == 25 ? "预约办理" : "系统更新",
        render: h => {
          return h(
            "div",
            {
              class: ["content"],
              on: {
                click: () => {
                  this.$router.push({
                    name: "sysNotDetail",
                    query: { id: data.id }
                  });
                }
              }
            },
            [
              h("div", { class: ["content_text"] }, data.title),
              h("div", { class: ["content_see"] }, "去看看")
            ]
          );
        }
      };
      this.$Notice.open(config);
    }
  },
  computed: {
    navItems() {
      return JSON.parse(this.$store.state.navigatorList);
    },
    navIndex() {
      return this.$store.state.navIndex;
    },
    userName() {
      return this.$store.state.GZHname;
    },
    GZHhead() {
      return this.$store.state.GZHhead;
    },
    isName() {
      if (this.$store.state.GZHname) {
        return true;
      } else {
        return false;
      }
    },
    isHead() {
      if (this.$store.state.GZHhead) {
        return true;
      } else {
        return false;
      }
    },
    navText() {
      return this.$store.state.navText;
    },
    // 是否已经登录 通过是否又communityId判断
    logined() {
      return this.$store.state.streetorcommunityid;
    },
    isPengJiang() {
      return location.hostname === "pj.shequyun.cn";
    },
    isShowManage(){ 
      return this.navItems.find(item=>item.type == 'page_community_management')?true:false
    }
  },
  watch: {
    logined() {
      if (this.logined) {
        console.log("-------------logined------------");
        this.initWebSocket();
      }
    }
  },
  beforeMount() {},
  mounted() {
    this.logined && this.initWebSocket();
  },
  created() {},
  destroyed() {
    // 页面离开时断开连接,清除定时器
    this.disconnect();
    clearInterval(this.timer);
  },
  components: {}
};
</script>
<style>
/*系统通知*/
.content:hover {
  cursor: pointer;
}
.content_text {
  font-size: 14px;
  margin-top: 22px;
  position: relative;
}
.content_text::after {
  content: "";
  position: absolute;
  top: -14px;
  height: 1px;
  right: 0;
  left: 0;
  background-color: #f1f1f1;
}
.content_see {
  margin-top: 10px;
  color: #556b93;
  font-size: 14px;
}
</style>

<style scoped lang="less">
/* 导航栏框 */
.nav-container {
  height: @navigatorHeight;
  background: url("../assets/images/navigator/navigator-bg.png") 0 0 no-repeat;
  background-color: #ff7743;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
}
/* 内部容器 */
.nav-inner {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
}
/* logo */
.logo {
  display: inline-block;
  min-width: 300px;
  height: 20px;
  margin-right: 50px;
}
.bkcc {
  color: white;
   background: url("../assets/images/navigator/bkcc-logo.png") 0 0 no-repeat;
}
.ipy {
  background: url("../assets/images/navigator/ipy.png") 0 0 no-repeat;
}
.logo--text {
  color: #fff;
  font-size: 24px;
  margin-right: 50px;
}
/* 导航条 开始 */
.nav-text {
  font-size: 20px;
  color: #fff;
  max-height: 3em;
  overflow: hidden;
}
.nav-list {
  display: flex;
  flex: 1;
}
.nav-item,
.dropdown-title {
  color: #fff;
  font-size: 18px;
  white-space: nowrap;
  margin-right: 50px;
  cursor: default;
  -webkit-user-select: none;
}
.active {
  position: relative;
}
.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -10px;
  width: 34px;
  height: 3px;
  border-radius: 1.5px;
  background-color: #d22b2b;
  transform: translateX(-50%);
}
/* 下拉导航栏 */
.dropdown-menu {
  /* background-color: #ff7743; */
}
.dropdown-item {
  font-size: 18px !important;
}
/* 导航条 结束 */
/* slot 外层样式 */
.nav-slot-warpper {
  margin-left: auto;
}
/* 账号信息 开始 */
.account {
  display: flex;
  align-items: center;
  cursor: default;
  position: relative;
}
.zhanwei {
  position: absolute;
  top: 50px;
  right: -10px;
  width: 145px;
  height: 20px;
  background: transparent;
}
.qp {
  position: absolute;
  top: 70px;
  right: -10px;
  padding: 20px 0;
  color: #666;
  font-size: 16px;
  background: #fff;
  box-shadow: 0 0 10px #ddd;
  border-radius: 0 0 10px 10px;
}
.system,
.unLogin {
  padding: 10px 64px 10px 30px;
}
.system:hover {
  background: #f1f1f1;
}
.unLogin:hover {
  background: #f1f1f1;
}
/* 通知 */
.notice {
  margin-right: 30px;
}
.icon-gonggao {
  position: relative;
  color: #ffdfd3;
  font-size: 24px;
}
.notice-number {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  background-color: #cd0200;
  color: #fff;
  font-size: 12px;
  transform: translate(40%, -40%);
}
/* 用户信息 */
.account-info {
  display: flex;
  align-items: center;
}
.detail-name {
  color: #fff;
  font-size: 16px;
  white-space: nowrap;
  font-weight: 600;
  margin-bottom: 6px;
}
.detail-type {
  color: #fff;
  font-size: 12px;
}
/* 用户头像 */
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #c6c5c3;
  margin-right: 10px;
  /* tmp css */
  line-height: 40px;
  text-align: center;
  background-color: #fff;
  color: #333;
}
.gzh-pic {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  margin-right: 10px;
}
/* 账号信息 结束 */
/* 系统公告 开始 */
.not-pic {
  width: 520px;
  height: 346px;
  border-radius: 10px;
  margin-top: 17px;
  margin-left: 17px;
}
.n-context {
  padding: 20px 17px;
  font-size: 18px;
  color: #333;
}
/deep/ .ivu-modal-body {
  width: 586px;
  height: 476px;
}
/deep/ .ivu-modal-content {
  width: 586px;
}
/* .not-con {
  width: 586px;
  height: 476px;
} */
/* 系统公告 结束 */
/* 媒体查询 */
@media screen and (max-width: 1100px) {
  .gt1100 {
    display: none;
  }
}
@media screen and (min-width: 1100px) {
  .lt1100 {
    display: none;
  }
}
</style>
